<template>
    <v-card class="cardBgColorStyle" >

        <v-toolbar dark dense color="tertiary">
            <v-toolbar-title> {{formTitle}} </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn title="關閉視窗" icon dark @click.native="closeDialog">
                <v-icon>mdi-close</v-icon>
            </v-btn>

        </v-toolbar>

        <v-card-text>
            <v-container grid-list-md style="padding: 0px!important;">

                <v-layout wrap row xs12 sm12 md12>

                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >院區代號*</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-select
                                    v-if="this.zoneNameList.length>0"
                                    v-model="zone"
                                    hide-details
                                    :items="zoneNameList"
                                    :item-text="zoneItemText"
                                    item-value="zone"
                            ></v-select>
                            <v-text-field v-else  :rules="[rules.required]" :disabled="this.editIndex!=-1"  v-model="zone"  clearable></v-text-field>
                        </v-flex>
                    </v-flex>

                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >看診日期*</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-text-field counter="7" :rules="[rules.required,rules.viewDateCounter]" :disabled="this.editIndex!=-1"  v-model="viewDate"   clearable></v-text-field>
                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >時段*</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>

                            <v-select
                                    :rules="[rules.required]" :disabled="this.editIndex!=-1"
                                    :items="apnList"
                                    item-value="value"
                                    item-text="apn"
                                    v-model="apn"
                            ></v-select>

                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >診間代號*</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-text-field :rules="[rules.required]" :disabled="this.editIndex!=-1"  v-model="clinicNo"   clearable></v-text-field>
                        </v-flex>
                    </v-flex>

                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >提示事件類別*</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>

                            <v-select
                                    :rules="[rules.required]" :disabled="this.editIndex!=-1"
                                    :items="noteEventList"
                                    item-value="value"
                                    item-text="note"
                                    v-model="noteEvent"
                            ></v-select>

                        </v-flex>
                    </v-flex>

                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >提示內容</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-textarea  filled rows="4" auto-grow :value="promptNote"  v-model="promptNote"  clearable ></v-textarea>
                        </v-flex>
                    </v-flex>


                </v-layout>


            </v-container>
        </v-card-text>
        <v-card-actions style="margin-bottom: 10px;margin-right: 10px;">
            <v-spacer></v-spacer>
            <v-btn  @click.native="closeDialog">取消</v-btn>
            <v-btn  @click.native="save">送出</v-btn>
        </v-card-actions>



    </v-card>
</template>

<script>
    export default {
        name: "EditClinicNoNote",
        props:['editIndex','isShow','editObj','zoneNameList'],
        data() {
            return {
                zone:'',//院區代號
                viewDate:'',//看診日期
                apn:'',//時段
                memo:'',//就醫者註記說明
                clinicNo:'',// 診間代號
                noteEvent:'',// 提示事件類別
                promptNote:'',// 提示內容
                modifyObj:{},
                rules:{
                    required: value => !!value || '必填.',
                    viewDateCounter:value => value!=null && value!=='' && value!==undefined && value.length <= 7 || '最多7個數字',

                },
                apnList:[
                    {apn:'上午診',value:'1'},
                    {apn:'下午診',value:'2'},
                    {apn:'晚上診',value:'3'},
                ],
                noteEventList:[
                    {note:'A-掛號輸入畫面',value:'A'},
                    {note:'B-掛號結果畫面',value:'B'}
                ]
            }
        },
        watch:{
            isShow(val){
                if(val==true&this.editIndex!=-1){
                    this.zone = this.editObj.zone==undefined?'':this.editObj.zone;
                    this.apn = this.editObj.apn==undefined?'':this.editObj.apn;
                    this.viewDate = this.editObj.viewDate==undefined?'':this.editObj.viewDate;
                    this.clinicNo = this.editObj.clinicNo==undefined?'':this.editObj.clinicNo;
                    this.noteEvent = this.editObj.noteEvent==undefined?'':this.editObj.noteEvent;
                    this.promptNote = this.editObj.promptNote==undefined?'':this.editObj.promptNote;
                }else {
                    this.zone ='A';
                    this.viewDate = '';
                    this.apn = '';
                    this.noteEvent = '';
                    this.clinicNo = '';
                    this.promptNote = '';
                }

            }
        },
        computed:{
            formTitle () {
                return this.editIndex == -1 ? '新增 診間掛號特別提示' : '編輯 診間掛號特別提示'
            },
        },
        methods:{
            zoneItemText: item => item.zone==''?'':item.zone + '-' + item.zoneName, //格式化 院區顯示文字
            closeDialog(){
                this.$emit('closeDialog');
            },
            save(){
                if(this.editIndex==-1){ //新增狀態
                    this.modifyObj = {
                        zone : this.zone==''||this.zone==null||this.zone==undefined?'':this.zone,
                        apn : this.apn,
                        noteEvent: this.noteEvent,
                        clinicNo: this.clinicNo,
                        promptNote: this.promptNote,
                        viewDate: this.viewDate,

                    }
                }else { //修改狀態
                    this.modifyObj = {
                        zone : this.zone==''||this.zone==null||this.zone==undefined?'':this.zone,
                        viewDate : this.viewDate,
                        apn : this.apn ,
                        noteEvent: this.noteEvent,
                        clinicNo: this.clinicNo,
                        promptNote: this.promptNote,
                    }
                }
                // parseFloat(this.sortByNo).toFixed(1);
                if(this.zone==''||this.viewDate==''||this.apn==''||this.noteEvent==''||this.clinicNo==''){
                    alert('請確認是否輸入院區代號、看診日期、時段、診間代號、提示事件類別')
                }else {
                    this.$emit('save',this.modifyObj);
                }

            }
        }
    }
</script>

<style scoped>

    .cardBgColorStyle{
        padding:0px 10px;
        background-color: rgba(255,255,255,1);
    }

    .labelFont{
        line-height: 62px;
    }


</style>